import produce from 'immer';
import { BehaviorSubject } from 'rxjs';
import useObservable from '../hooks/useObservable';

// loading : true false - interface sub and setState

export interface IUiState {
  isLoading: boolean;
  success_message: string;
  error_message: string;
  info_message: string;
}

const initialState: IUiState = {
  isLoading: false,
  success_message: '',
  error_message: '',
  info_message: '',
};
const subject = new BehaviorSubject(initialState);

type UiStoreMessageTypes = keyof Omit<IUiState, 'isLoading'>;

const setUiStoreMessage = (type: UiStoreMessageTypes, message: string): void => {
  const state = produce(subject.value, (draftState) => {
    draftState[type] = message;
  });
  subject.next(state);
};

export const uiStore = {
  /**
   * Used to Set Loader
   * @param loading
   */
  setLoader: (loading: boolean): void => {
    const state = produce(subject.value, (draftState) => {
      draftState.isLoading = loading;
    });
    subject.next(state);
  },
  /**
   * used to set Success Message
   * @param message
   */
  setSuccessMessage: (message: string): void => {
    setUiStoreMessage('success_message', message);
  },
  /**
   * Clears Success Message
   */
  clearSuccessMessage: (): void => {
    setUiStoreMessage('success_message', '');
  },
  /**
   * Sets Error Message
   * @param message
   */
  setErrorMessage: (message: string): void => {
    setUiStoreMessage('error_message', message);
  },
  /**
   * Clears Error Messages
   */
  clearErrorMessage: (): void => {
    setUiStoreMessage('error_message', '');
  },
  /**
   *Set Message
   * @param message
   */
  setInfoMessage: (message: string): void => {
    setUiStoreMessage('info_message', message);
  },
  /**
   *Clear Message
   */
  clearInfoMessage: (): void => {
    setUiStoreMessage('info_message', '');
  },
};

export default function useUiStore(): IUiState {
  return useObservable<IUiState>(subject, subject.value);
}
